export const TABS = {
  APPOINTMENTS: 'APPOINTMENTS',
  ENCOUNTERS: 'ENCOUNTERS',
}
